import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class PageOptionsVM extends CommonOptionVM {
  not_visible?: boolean
  image_marker_id?: string

  constructor(data: Partial<PageOptionsVM> = {}) {
    super(data)
    this.not_visible = data.not_visible ?? undefined
    this.image_marker_id = data.image_marker_id ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default PageOptionsVM
